import { PageLayout } from "@/shared/components";
import type { FilterDefinition } from "@/shared/components/ResourceView";
import {
  coreSessionFilters,
  CreateSessionButton,
  sessionResourceIdFilter,
  SessionsList,
} from "@/shared/components/sessions";

/**
 * Filter-menu surface for the unscoped `/sessions` page. Both
 * cross-aggregate id rows are user-narrowable here because no server-side
 * scope is applied.
 */
const sessionsPageFilterDefinitions: FilterDefinition[] = [
  ...coreSessionFilters,
  {
    type: "string",
    field: "dataset.dataset_id",
    name: "Dataset ID",
    allowedComparators: sessionResourceIdFilter.comparators,
    icon: sessionResourceIdFilter.icon,
  },
  {
    type: "string",
    field: "device.device_id",
    name: "Device ID",
    allowedComparators: sessionResourceIdFilter.comparators,
    icon: sessionResourceIdFilter.icon,
  },
];

/**
 * Top-level `/sessions` page. Renders the shared `SessionsList` with the
 * unscoped filter picker and a toolbar entry point into the create-session
 * flow.
 */
export function SessionsPage() {
  return (
    <PageLayout title="Roboto - Sessions" headerContentLeft="Sessions">
      <SessionsList
        filterDefinitions={sessionsPageFilterDefinitions}
        noRowsContent="No sessions created yet"
        actions={<CreateSessionButton />}
      />
    </PageLayout>
  );
}
